import React from "react"

import GuestPaymentMethodSelectForm from "~components/pages/account/payment-methods/guest-payment-method-select-form"
import PaymentMethodSelectForm from "~components/pages/account/payment-methods/payment-method-select-form"
import type { PaymentMethodState } from "~utils/use-payment-method-state"
import useUser from "~utils/use-user"

interface Props {
    readonly selectedId: string | null
    readonly onChange: (update: Partial<PaymentMethodState>) => void
    readonly isExternalPaymentMethod?: boolean
    readonly isPayWithCheckEnabled?: boolean
}

export default function GuestOrUserPaymentMethodSelectForm({
    selectedId,
    onChange,
    isExternalPaymentMethod,
    isPayWithCheckEnabled,
}: Props) {
    const { user } = useUser()

    const PaymentMethodForm = user
        ? PaymentMethodSelectForm
        : GuestPaymentMethodSelectForm

    return (
        <PaymentMethodForm
            selectedId={selectedId}
            isExternalPaymentMethod={isExternalPaymentMethod}
            isPayWithCheckEnabled={isPayWithCheckEnabled}
            onChange={onChange}
        />
    )
}
